import LocationMenusForm from "./location-menus-form";

export default LocationMenusForm;